import React, { useState } from "react";
import debounce from "debounce-promise";
import qs from "query-string";

import { applicationStyles as styles } from "../ApplicationLayout";
import { FieldShell, showError } from "../fields";

export const fetchAutocomplete = debounce(
    (input) => {
        if (!input) return Promise.resolve([]); // Don't fetch on empty input

        const queryString = qs.stringify({
            nameStart: input,
            minPopulation: 250000,
        });

        return fetch(
            `https://6i9d7zjpoa.execute-api.eu-west-1.amazonaws.com/production/?${queryString}`
        )
            .then(res => res.json())
            .catch(() => []);
    },
    300
);

export const HomeCityField = ({ input, meta, label, hint, placeholder }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const handleChange = (event) => {
        const value = event.target.value;
        input.onChange({ name: value, geonamesId: "" });

        if (value) {
            setShowSuggestions(true);
            fetchAutocomplete(value).then(setSuggestions);
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    };

    const handleSelect = (city) => {
        input.onChange({ name: `${city.displayName}, ${city.country}`, geonamesId: city.geonamesId });
        setSuggestions([]);
        setShowSuggestions(false);
    };

    return (
        <FieldShell id={input.name} label={label} hint={hint} meta={meta}>
            <div className={styles.autocomplete}>
                <div className={`${styles.box} ${styles.inputBox} ${showError(meta) ? styles.boxInvalid : ""}`}>
                    <input
                        {...input}
                        id={input.name}
                        className={styles.input}
                        type="text"
                        autoComplete="off"
                        placeholder={placeholder}
                        value={input?.value?.name || ""}
                        onChange={handleChange}
                        onFocus={() => input.value?.name && setShowSuggestions(true)}
                        onBlur={() => {
                            setTimeout(() => {
                                setShowSuggestions(false);
                                // No id means it was typed, not picked, so it is not a real place.
                                if (!input.value?.geonamesId) input.onChange(null);
                            }, 0);
                        }}
                    />
                </div>

                {showSuggestions && suggestions.length > 0 && (
                    <div className={styles.suggestions}>
                        {suggestions.map((city) => (
                            <button
                                key={city.geonamesId}
                                type="button"
                                className={styles.suggestion}
                                onMouseDown={() => handleSelect(city)}
                            >
                                {city.displayName}
                                <span className={styles.suggestionCountry}>, {city.country}</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </FieldShell>
    );
};

export function ContactInfoCityInput({ value, onChange, error }) {
    const [suggestions, setSuggestions] = useState([])
    const [showSuggestions, setShowSuggestions] = useState(false)

    const handleInputChange = (e) => {
        const val = e.target.value
        onChange({ name: val, geonamesId: "" })
        if (val) {
            setShowSuggestions(true)
            fetchAutocomplete(val).then(setSuggestions)
        } else {
            setSuggestions([])
            setShowSuggestions(false)
        }
    }

    const handleSelect = (city) => {
        onChange({
            name: `${city.displayName}, ${city.country}`,
            geonamesId: city.geonamesId,
            __typename: "City",
        })
        setSuggestions([])
        setShowSuggestions(false)
    }

    return (
        <div className="relative">
            <label className="block mb-1 text-black">Home base city:</label>
            <input
                type="text"
                className="w-full text-black border p-2 rounded bg-gray-300"
                style={{
                    borderColor: error ? "#e53935" : "#404040"
                }}
                value={value?.name || ""}
                onChange={handleInputChange}
                onFocus={() => {
                    if (value?.name) setShowSuggestions(true)
                }}
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}

            {showSuggestions && suggestions.length > 0 && (
                <div className="absolute z-10 w-full bg-white border max-h-60 overflow-y-auto text-black">
                    {suggestions.map((city) => (
                        <div
                            key={city.geonamesId}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                            onMouseDown={() => handleSelect(city)}
                        >
                            {city.displayName}, {city.country}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
